import React, { useEffect, useRef, useState } from "react";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import useDisableBrowserBack from "../../hooks/useDisableBrowserBack";
import useReadCookies from "../../hooks/useReadCookies";
import { getGroupsStatus } from '../../dashboard/dashboardSlice';

function GroupsSummary() {
  useDisableBrowserBack();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();

  let { cookieGameId, cookieGroupId } = useReadCookies();

  const groups = useSelector((state) => state.dashboard.groupStatus);
  const [showMenuDrawer, setShowMenuDrawer] = useState(false);

  useEffect(() => {
    dispatch(getGroupsStatus(cookieGameId));
    let showDrawerTimer;

    if (!showMenuDrawer) {
      showDrawerTimer = setTimeout(() => {
        setShowMenuDrawer(true);
      }, 10000)
    }

    return () => {
      if (showDrawerTimer) {
        clearTimeout(showDrawerTimer);
      }
    }

  }, [showMenuDrawer]);

  useEffect(() => {
    console.log(groups)
  }, [groups])

  const handleContinueButton = (e) => {
    e.preventDefault();
    navigate("/app/game/");
  }

  return (
    <div className="mobileContainer blackNights groups-summary-screen">
      <div className="summary-screen-container">
        <div className="summary-wrapper single-line">
          <div className="title-wrapper">
            <h3>{t("student.groups_overview.your_group")}</h3>
          </div>
          <ul className="group-list frameGoldOpen">
          {groups &&
            groups.map((group, key) =>
              group.group_id == cookieGroupId ? (
            <li className="group-item current" key={group.group_id}>
              <div className="group-position"><span className="number">{key + 1}</span></div>
              <div className="group-title">
                <div className="group-name">{group.name}</div>
                <div className="group-score">{group.players && group.players.map((player) => player.name).join(", ")}</div>
              </div>
              <div className="group-avatar">
                <img src={`/storage/avatar/group_${group.group_id}.png`} />
              </div>
            </li>
            ) : (
              ""
            )
          )}
          </ul>
        </div>
        <div className="summary-wrapper">
          <div className="title-wrapper">
            <h3>{t("student.groups_overview.rankings")}</h3>
          </div>
          <ul className="group-list frameGoldOpen multi">
          {groups &&
            groups.map((group, key) => (
              <li className={`group-item ${key === 0 ? 'first' : ''} ${key === 1 ? 'second' : ''} ${key === 2 ? 'third' : ''} ${key > 2 ? 'neutral' : ''}`}>
              <div className="group-position"><span className="number">{key + 1}</span></div>
              <div className="group-title">
                <div className="group-name">{group.name}</div>
                <div className="group-score">{group.players && group.players.map((player) => player.name).join(", ")}</div>
              </div>
              <div className="group-avatar">
                <img src={`/storage/avatar/group_${group.group_id}.png`} />
              </div>
            </li>
            ))}
          </ul>
        </div>
        {showMenuDrawer &&
          <div className='navigationDrawer variant4 enableInAnimation'>
            <button className='submitButton enableInAnimation' onClick={handleContinueButton}>
              <span className='caption'>Opniew</span>
            </button>
          </div>
        }
      </div>
    </div>
  );
}

export default GroupsSummary;